import { Loader } from "@googlemaps/js-api-loader";
import localize from '../localize';

(function () {
  'use strict';
  const suggestField = document.querySelector('.js-station-search-field');
  const suggestWrapper = document.querySelector('.js-suggest');
  const searchForm = document.querySelector('.js-search-form');
  const searchResultsAndMap = document.querySelector('.js-station-search-results-and-map');
  const backLink = document.querySelector('.js-station-search-back-link');
  const orderedStationsToggle = document.querySelector('.js-ordered-stations-toggle');
  const orderedStations = document.querySelector('.js-ordered-stations');
  const orderedStationsContent = document.querySelector('.js-ordered-stations-content');
  const accordionButtons = Array.from(document.querySelectorAll('.js-ordered-stations .accordion-button'));
  const accordionCollapse = Array.from(document.querySelectorAll('.js-ordered-stations .accordion-collapse'));

  const DONE= 4;
  const OK= 200;
  const initialPosition = {coords:{latitude:50.91885205,longitude:6.93768676}};

  let appointmentList = {
    initialize: function () {
      if (suggestField) {
        document.body.addEventListener('click', function () {
          suggestWrapper.classList.remove('show');
          suggestWrapper.setAttribute('aria-expanded', false);
        });
        suggestField.addEventListener('keyup', function (event) {
          if (event.key === 'ArrowDown') {
            let firstAnchorInSuggest =
              document.querySelector('.js-suggest .js-suggest-list__item:first-child .js-suggest-list__anchor');

            if (firstAnchorInSuggest) {
              firstAnchorInSuggest.focus();
            }
          } else {
            appointmentList.callSuggest();
          }
        });
        suggestField.addEventListener('focus', function () {
          appointmentList.callSuggest();
        });
      }

      if (searchForm) {
        searchForm.addEventListener('submit', function (event) {
          event.preventDefault();
          if (suggestField.value) {
            appointmentList.callStationSearch();
          } else {
            let emptySearchErrorText = document.querySelector('.js-empty-search-error-text');
            if (!emptySearchErrorText) {
              emptySearchErrorText = document.createElement('P');
              emptySearchErrorText.textContent = localize('js.search.empty');
              emptySearchErrorText.classList.add('js-empty-search-error-text', 'empty-search-error-text');

              searchResultsAndMap.prepend(emptySearchErrorText);
            }
          }
        });

        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            appointmentList.callInitialStationSearch,
            function() {
              appointmentList.callInitialStationSearch(initialPosition);
            }
          );
        } else {
          appointmentList.callInitialStationSearch(initialPosition);
        }
      }

      if (backLink) {
        backLink.addEventListener('click', function(e) {
          e.preventDefault();
          history.back();
        });
      }

      if (orderedStationsToggle && orderedStations && accordionButtons) {
        accordionButtons.forEach(function(btn) {
          btn.setAttribute('inert', 'inert');
        });

        accordionCollapse.forEach(function(collapse) {
          collapse.addEventListener("shown.bs.collapse", function () {
            let stationList = collapse.querySelector('.js-ordered-stations-list');
            orderedStations.style.maxHeight = (orderedStationsContent.offsetHeight + stationList.offsetHeight)  + 'px';
          });
        });

        orderedStationsToggle.addEventListener('click', function(e) {
          e.preventDefault();
          if (orderedStations.classList.contains('ordered-stations--closed')) {
              this.textContent = localize('js.hide_stations_by_zip');
              this.setAttribute('aria-expanded', true);
              orderedStations.classList.remove('ordered-stations--closed');
              orderedStations.removeAttribute('inert');
              orderedStations.style.maxHeight = orderedStationsContent.offsetHeight + 'px';
              accordionButtons.forEach(function(btn) {
                btn.removeAttribute('inert');
              });
            } else {
              this.textContent = localize('js.show_stations_by_zip');
            this.setAttribute('aria-expanded', false);
              orderedStations.classList.add('ordered-stations--closed');
            orderedStations.setAttribute('inert', 'inert');
              orderedStations.style.maxHeight = 0;
              accordionButtons.forEach(function(btn) {
                btn.setAttribute('inert', 'inert');
              });
            }
        });
      }
    },
    callInitialStationSearch: function(position) {
      let ajaxUrl = suggestField.getAttribute('data-search-ajax-url');
      let insurance = suggestField.getAttribute('data-insurance');

      if (ajaxUrl && position.coords) {
        let xhr = new XMLHttpRequest();
        xhr.open('POST', ajaxUrl);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.send('tx_jaappointment_search[lat]=' +
          position.coords.latitude +
          '&tx_jaappointment_search[lon]=' +
          position.coords.longitude +
          '&tx_jaappointment_search[affiliatesubid2]=' + affiliatesubid2 +
          '&tx_jaappointment_search[insurance]=' + insurance
        );

        xhr.onreadystatechange = function () {
          if (xhr.readyState === DONE) {
            if (xhr.status === OK) {
              suggestWrapper.classList.remove('show');
              searchResultsAndMap.innerHTML = xhr.responseText;
              appointmentList.bindStationSearchPaginationLinks();

              appointmentList.initMap();
            }
          }
        }
      }
    },
    initMap: async function()  {
      const loader = new Loader({
        apiKey: apiKey,
        version: "3.61",
      });

      if (window.innerWidth >= 992) {
        let mapContainer = document.querySelector('.ja-appointment-map');

        if (mapContainer) {
          const [{Map}, {Marker}] = await Promise.all([
            loader.importLibrary('maps'),
            loader.importLibrary('marker')
          ]);

          let map = new Map(
            mapContainer,
            {
              center: {
                lat: parseFloat(mapContainer.getAttribute('data-lat')),
                lng: parseFloat(mapContainer.getAttribute('data-lng'))
              },
              zoom: 9,
              mapId: '1713343449'
            }
          );

          let distances = JSON.parse(document.querySelector('.js-distances-data').innerHTML);

          if (stations) {
            let markers = [];
            let infowindows = [];
            stations.forEach(function(station) {
              markers[station.uid] = new google.maps.marker.AdvancedMarkerElement({
                map: map,
                position: {
                  lat: parseFloat(station.lat),
                  lng: parseFloat(station.lng)
                },
                title: station.title,
              });

              let markerContent = document.createElement("div");
              markerContent.innerHTML = '<h4 class="infowindow__title">' + station.title + '</h4>';

              if (distances[station.uid]) {
                markerContent.innerHTML += '<p class="infowindow__p infowindow__p--distance">' +
                  '<svg class="infowindow__icon" aria-hidden="1"><use xlink:href="#arrows"></use></svg>' +
                  distances[station.uid] + ' km' +
                  '</p>';
              }

              markerContent.innerHTML += '<p class="infowindow__p">' + station.address + '</p>' +
                '<p class="infowindow__p">' + localize('js.phone') + ' ' + station.phone + '</p>' +
                '<p class="infowindow__p">' + station.opening_hours + '</p>' +
                '<a href="' + station.link + '" class="infowindow__button">' +
                localize('js.book_appointment') +
                '</a>';

              infowindows[station.uid] = new google.maps.InfoWindow({
                content: markerContent,
                ariaLabel: station.title,
              });

              markers[station.uid].addListener('gmp-click', () => {
                infowindows[station.uid].open({
                  anchor: markers[station.uid],
                  map,
                });
              });
            });
          }
        }
      }
    },
    callStationSearch: function() {
      let ajaxUrl = suggestField.getAttribute('data-search-ajax-url');
      let insurance = suggestField.getAttribute('data-insurance');

      if (ajaxUrl && suggestField.value) {
        let xhr = new XMLHttpRequest();
        xhr.open('POST', ajaxUrl);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.send(
          'tx_jaappointment_search[query]=' + encodeURI(suggestField.value) +
          '&tx_jaappointment_search[affiliatesubid2]=' + affiliatesubid2 +
          '&tx_jaappointment_search[insurance]=' + insurance
        );

        xhr.onreadystatechange = function () {
          if (xhr.readyState === DONE) {
            if (xhr.status === OK) {
              suggestWrapper.classList.remove('show');
              suggestWrapper.setAttribute('aria-expanded', false);
              searchResultsAndMap.innerHTML = xhr.responseText;
              appointmentList.bindStationSearchPaginationLinks();
              appointmentList.initMap();
            }
          }
        }
      }
    },
    bindStationSearchPaginationLinks: function () {
      let paginationLinks= Array.from(document.querySelectorAll('.js-station-search__page-link'));

      paginationLinks.forEach(anchor => {
        anchor.addEventListener('click', function(event) {
          event.preventDefault();
          if (this.hasAttribute('href')) {
            let xhr = new XMLHttpRequest();
            xhr.open('GET', this.getAttribute('href'));
            xhr.responseType = 'document'
            xhr.send();

            xhr.onreadystatechange = function () {
              if (xhr.readyState === DONE) {
                if (xhr.status === OK) {
                  suggestWrapper.classList.remove('show');
                  suggestWrapper.setAttribute('aria-expanded', false);
                  let ajaxResult = xhr.responseXML.querySelector('.js-station-search-results');
                  let currentResult = document.querySelector('.js-station-search-results');

                  if (ajaxResult && currentResult) {
                    currentResult.innerHTML = ajaxResult.innerHTML;
                  }
                  appointmentList.bindStationSearchPaginationLinks();
                }
              }
            }
          }
        });
      });
    },
    callSuggest: function() {
      let ajaxUrl = suggestField.getAttribute('data-suggest-ajax-url');

      if (ajaxUrl && suggestField.value) {
        let xhr = new XMLHttpRequest();
        xhr.open('POST', ajaxUrl);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.send('tx_jaappointment_suggest[query]=' + encodeURI(suggestField.value));

        xhr.onreadystatechange = function () {
          if (xhr.readyState === DONE) {
            if (xhr.status === OK) {
              if (!xhr.responseText.includes('js-suggest-no-results')) {
                suggestWrapper.innerHTML = xhr.responseText;
                suggestWrapper.classList.add('show');
                suggestWrapper.setAttribute('aria-expanded', true);

                let anchors= Array.from(document.querySelectorAll('.js-suggest .js-suggest-list__anchor'));
                anchors.forEach(anchor => {
                  anchor.addEventListener('click', function(event) {
                    event.preventDefault();
                    let anchor = event.target.closest('.js-suggest-list__anchor');
                    suggestField.value = anchor.firstElementChild.textContent + ' ' +
                      anchor.firstElementChild.nextElementSibling.textContent;
                    suggestWrapper.classList.remove('show');
                    suggestWrapper.setAttribute('aria-expanded', false);
                    appointmentList.callStationSearch();
                  });
                  anchor.addEventListener('keyup', function(event) {
                    if (event.key === 'ArrowDown') {
                      let parentListItem = event.target.closest('.js-suggest-list__item');
                      if (parentListItem) {
                        let nextListItem= parentListItem.nextElementSibling;
                        if (nextListItem) {
                          let nextAnchor= nextListItem.firstElementChild;
                          if (nextAnchor) {
                            nextAnchor.focus();
                          }
                        }
                      }
                    } else {
                      if (event.key === 'ArrowUp') {
                        let parentListItem = event.target.closest('.js-suggest-list__item');
                        if (parentListItem) {
                          let prevListItem= parentListItem.previousElementSibling;
                          if (prevListItem) {
                            let prevAnchor= prevListItem.firstElementChild;
                            if (prevAnchor) {
                              prevAnchor.focus();
                            }
                          } else {
                            suggestField.focus();
                          }
                        }
                      }
                    }
                  });
                });
              } else {
                suggestWrapper.classList.remove('show');
                suggestWrapper.setAttribute('aria-expanded', false);
              }
            }
          }
        }
      } else {
        suggestWrapper.classList.remove('show');
        suggestWrapper.setAttribute('aria-expanded', false);
      }
    }
  }

  if (suggestField) {
    appointmentList.initialize();
  }
})();
